// @ts-nocheck
import { useTranslation } from "react-i18next";
import { SwapOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button, Image, Input, Upload } from "antd";
import { Toast } from "antd-mobile";
import { useEffect, useState,useRef } from "react";
import QRCode from "qrcodejs2";
import { imageConfig } from "../../../../config/config";

export default function CenterPage({
  coinList,
  sendRecharge,
  use,
  setUse,
  coinPriceData,
  pledgeNum,
  leftNum
}) {
  const navigate = useNavigate();
  const [addrId, setAddrId] = useState(0);
  const [img, setImg] = useState("");
  const [num, setNum] = useState("");
  const { t: translate } = useTranslation();
  const inputRef = useRef(null);
  let qrcode = null;

  //上传
  const handleChange = (info) => {
    if (info.file.status === "done") {
      if (info.file.response && info.file.response.ok) {
        Toast.show({
          content: `${info.file.name} ${translate(getText("上傳成功"))}`,
        });
        const data = info.file.response;
        setImg(data.data);
      } else {
        Toast.show({ content: translate(getText("上传失败")) });
      }
    } else if (info.file.status === "error") {
      Toast.show({ content: translate(getText("上传失败")) });
    }
  };

  const creatQrCode = () => {
    let text = use?.czaddress;
    document.getElementById("qrcode").innerHTML = "";
    qrcode = new QRCode(document.getElementById("qrcode"), {
      text: text, //二维码内容字符串
      width: 100, //图像宽度
      height: 100, //图像高度
      colorDark: "#000000", //二维码前景色
      colorLight: "#ffffff", //二维码背景色
      correctLevel: QRCode.CorrectLevel.H, //容错级别
    });
  };

  const handleCopy = (value) => {
    if (copy(value)) {
      Toast.show({ content: translate(getText("成功")) });
    }
  };
  useEffect(() => {
    creatQrCode();
  }, [use]);
  return (
    <div className="w-full bg-neutral-900 text-neutral-100 py-4">
      <div className="px-4">
        {/* QR Code Section */}
        <div className="flex justify-center mb-6">
          <div className="relative p-4 bg-white rounded-lg shadow-md">
            <div className="qrcodeDiv">
              <div className="qrcodeiconDiv">
                <div className="qrcodeiconDiv1"></div>
                <div className="qrcodeiconDiv2"></div>
                <div className="qrcodeiconDiv3"></div>
                <div className="qrcodeiconDiv4"></div>
                <div id="qrcode" className="rechargeCenterInfo-4"></div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Save QR Code Button */}
        <div className="flex justify-center mb-6">
          <button className="px-5 py-2 bg-primary text-white rounded-full font-medium">
            {translate(getText("保存二維碼"))}
          </button>
        </div>
        
        {/* Address Section */}
        <div className="bg-neutral-800 rounded-lg p-4 mb-6 border border-neutral-700">
          <div className="mb-2">
            <h1 className="text-lg font-bold text-neutral-100 mb-1">{translate(getText("還款地址"))}</h1>
            <p className="text-neutral-300 break-all">{use?.czaddress}</p>
          </div>
          <div
            className="mt-3 flex justify-center"
            onClick={() => {
              handleCopy(use?.czaddress);
            }}
          >
            <button className="px-4 py-2 border border-primary text-primary rounded-lg">
              {translate(getText("複製地址"))}
            </button>
          </div>
        </div>
        
        {/* Form Section */}
        <div className="bg-neutral-800 rounded-lg p-4 border border-neutral-700">
          <ul className="space-y-6">
            {/* Repayment Amount */}
            <li className="pb-4 border-b border-neutral-700">
              <p className="text-neutral-300 mb-2">
                {translate(getText("還款數量"))}:{translate(getText("剩餘"))}{leftNum}(USDT)
              </p>
              <div className="bg-neutral-700 rounded p-1">
                <div className="flex items-center">
                  <input
                    type="number"
                    id="usdtmoney"
                    name="usdtmoney"
                    autoComplete="off"
                    className="bg-transparent text-neutral-100 px-3 py-2 w-full focus:outline-none"
                    ref={inputRef}
                  />
                </div>
              </div>
            </li>

            {/* Conversion Section */}
            <>
              <div className="flex justify-center">
                <SwapOutlined
                  style={{
                    transform: "rotate(90deg)",
                    color: "#8B5CF6",
                    fontSize: 18,
                    border: "2px solid #8B5CF6",
                    borderRadius: "50%",
                    padding: "5px 5px",
                  }}
                />
              </div>
              <li className="pb-4 border-b border-neutral-700">
                <p className="text-neutral-300 mb-2">
                  {translate(getText("转化數量"))}({use?.name?.toUpperCase()})
                </p>
                <div className="bg-neutral-700 rounded p-1">
                  <div className="flex items-center">
                    <input
                      disabled
                      type="number"
                      id="convertedAmount"
                      name="convertedAmount"
                      autoComplete="off"
                      className="bg-transparent text-neutral-100 px-3 py-2 w-full focus:outline-none"
                      value={
                        `${pledgeNum / coinPriceData?.close}` == "NaN"
                          ? coinPriceData?.close == undefined
                            ? pledgeNum
                              ? pledgeNum
                              : 0
                            : pledgeNum
                            ? "..."
                            : 0
                          : (pledgeNum / coinPriceData?.close).toFixed(2)
                      }
                      readOnly
                    />
                  </div>
                </div>
              </li>
            </>
            
            {/* Upload Section */}
            <li className="pb-4">
              <p className="text-neutral-300 mb-3">
                {translate(getText("上傳支付詳情截圖"))}
              </p>
              <div className="bg-neutral-700 p-4 rounded-lg flex justify-center">
                <Upload
                  name="file"
                  listType="picture-card"
                  accept="image/*"
                  showUploadList={false}
                  action={imageConfig.uploadUrl}
                  onChange={handleChange}
                >
                  <div className="flex items-center justify-center flex-col">
                    <Image
                      preview={false}
                      style={{
                        maxHeight: "100px",
                        maxWidth: "100px",
                      }}
                      src={imageConfig.baseImageUrl + img}
                      fallback="data:image/png;base64,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"
                    />
                    {!img && <p className="mt-2 text-neutral-400">{translate(getText("點擊上傳圖片"))}</p>}
                  </div>
                </Upload>
              </div>
            </li>
          </ul>
          
          {/* Submit Button */}
          <div className="mt-6">
            <button
              className="w-full py-3 bg-primary text-white rounded-lg font-medium"
              onClick={() => {
                if (!pledgeNum) {
                  return;
                }
                if (
                  coinPriceData?.close != undefined &&
                  !coinPriceData?.close
                ) {
                  return;
                }
                sendRecharge({
                  coinname: use.name,
                  czaddress: use.czaddress,
                  payimg: img,
                  zznum: inputRef.current.value,
                  currenyName: use?.name?.toUpperCase(),
                  currenyNum:
                    `${inputRef.current.value / coinPriceData?.close}` == "NaN"
                      ? inputRef.current.value
                      : inputRef.current.value / coinPriceData?.close,
                  czline: use.czline,
                  plegdeNum:inputRef.current.value,
                });
                setNum("");
                setImg("");
              }}
            >
              {translate(getText("提交"))}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
